/* eslint-disable no-unused-vars */
export enum Priority {
  INFO,
  LOW,
  MEDIUM,
  HIGH,
}
